import { useContext } from "react";
import useHttp from "./useHttp";
import PatientsContext from "../context/PatientsContext";
import { getEnvironmentApiUrl } from "../services/General";
import { Patient } from "../interfaces/Patient";

const useDeletePatientAlert = (patientID: Patient['id']) => {

    const { setPatients } = useContext(PatientsContext);

    const { sendRequest } = useHttp();

    const deletePatientAlert = (id: number, type: 'param' | 'inquiry') => {
        setPatients(oldPatients => oldPatients.map(p => {
            if (p.id !== patientID) return p;
            const newCases = [...p.cases];
            if (type === 'param') {
                const patientAlerts = newCases[0]?.patient_score_param_alerts?.filter(pia => pia.id !== id);
                if (!patientAlerts) return p;
                newCases[0].patient_score_param_alerts = patientAlerts;
            }
            if (type === 'inquiry') {
                const patientAlerts = newCases[0]?.patient_inquiry_alerts?.filter(pia => pia.id !== id);
                if (!patientAlerts) return p;
                newCases[0].patient_inquiry_alerts = patientAlerts;
            }
            return { ...p, cases: newCases };
        }));
    }

    const handleDelete = (id: number, type: 'param' | 'inquiry') => (evt: React.MouseEvent<HTMLButtonElement>) => {
        evt.stopPropagation();
        const url = type === 'inquiry' ? 'patient_inquiry_alert/' : 'score_parameter_alert/patient_score_parameter_alert/';
        sendRequest({
            url: getEnvironmentApiUrl() + url + id,
            method: 'DELETE',
        }, () => deletePatientAlert(id, type));
    };

    return { handleDelete };


}

export default useDeletePatientAlert;